const migrationQueries = {
    "matrixRecently": `
        //------------------------------------------------------------------------------
        //                MIGRACIÓN INTERNA MATRIZ BÁSICA RECIENTE ({daType})
        //------------------------------------------------------------------------------
        
        TABLE  {tableName}
        FREQ   {daType}RES BY {daType}RES5
        FILTER EDAD > 4 AND {daType}RES > 0 AND {daType}RES5 > 0 {filterText}
        ZERO   
        TITLE \\"{title}\\"
        OUTPUTFILE JSON \\"{outputNameJSON}.json\\" OVERWRITE
    `,
    "matrixLifetime": `
        //------------------------------------------------------------------------------
        //                MIGRACIÓN INTERNA MATRIZ BÁSICA TODA LA VIDA ({daType})
        //------------------------------------------------------------------------------
        
        TABLE  {tableName}
        FREQ   {daType}RES BY {daType}NAC
        FILTER {daType}RES > 0 AND {daType}NAC > 0 {filterText}
        ZERO
        TITLE \\"{title}\\"
        OUTPUTFILE JSON \\"{outputNameJSON}.json\\" OVERWRITE
    `,
    "indexRecently": `
        //------------------------------------------------------------------------------
        //                INDICADORES MIGRACIÓN INTERNA RECIENTE (DAM)
        //------------------------------------------------------------------------------
        
        //RESIDENCIA HABITUAL
        TABLE  DR_RESHAB_{indexNumber}
        FREQ   {daType}RES
        FILTER EDAD > 4 AND {daType}RES5 > 0 AND {daType}RES > 0 {filterText}
        TITLE \\"RESIDENCIA HABITUAL\\"
        
        //RESIDENCIA HACE 5 AÑOS
        TABLE  DR_RESREC_{indexNumber}
        FREQ   {daType}RES5
        FILTER EDAD > 4 AND {daType}RES5 > 0 AND {daType}RES > 0 {filterText}
        TITLE \\"RESIDENCIA HACE 5 AÑOS\\"
        
        //NO MIGRANTES
        TABLE  DR_NOMIGRA_{indexNumber}
        FREQ   {daType}RES
        FILTER {daType}RES = {daType}RES5 {filterText}
        TITLE \\"NO MIGRANTES\\"
        
        //INMIGRANTES: RESTA DE LA POBLACIÓN RESIDENTE A LA FECHA DEL CENSO MENOS LOS NO MIGRANTES
        TABLE DR_INMIG_{indexNumber}
        TABOP DR_RESHAB_{indexNumber} - DR_NOMIGRA_{indexNumber}
        TITLE \\"INMIGRANTES\\"
        
        //EMIGRANTES: RESTA DE LA POBLACIÓN EN SU LUGAR DE RESIDENCIA 5 AÑOS ANTES DEL CENSO, MENOS LOS NO MIGRANTES
        TABLE DR_EMIG_{indexNumber}
        TABOP DR_RESREC_{indexNumber} - DR_NOMIGRA_{indexNumber}
        TITLE \\"EMIGRANTES\\"
        
        //MIGRACIÓN NETA: RESTA ENTRE LOS INMIGRANTES MENOS LOS EMIGRANTES 
        TABLE DR_MIGNETA_{indexNumber}
        TABOP DR_INMIG_{indexNumber} - DR_EMIG_{indexNumber}
        TITLE \\"MIGRACIÓN NETA\\"
        
        //MIGRACIÓN BRUTA: SUMA DE LOS INMIGRANTES MÁS LOS EMIGRANTES
        TABLE DR_MIGBRUTA_{indexNumber}
        TABOP DR_INMIG_{indexNumber} + DR_EMIG_{indexNumber}
        TITLE \\"MIGRACIÓN BRUTA\\"
        
        //TASA DE INMIGRACIÓN: POBLACIÓN DE INMIGRANTES DIVIDIDA POR 5.
        //DIVIDIDO POR LA SUMA DE LA POBLACIÓN RESIDENTE EN LA FECHA DEL CENSO 
        //Y LA POBLACIÓN RESIDENTE HACE 5 AÑOS DIVIDIDA POR 2, MULTIPLICADO POR 1000 
        TABLE DR_TASAINMI_{indexNumber}
        TABOP ( ( DR_INMIG_{indexNumber} / 5 ) / ( ( DR_RESHAB_{indexNumber} + DR_RESREC_{indexNumber} ) / 2 ) ) * 1000
        DECIMALS 2
        TITLE \\"TASA DE INMIGRACIÓN\\"
        
        //TASA DE EMIGRACIÓN: POBLACIÓN DE EMIGRANTES DIVIDIDA POR 5.
        //DIVIDIDO POR LA SUMA DE LA POBLACIÓN RESIDENTE EN LA FECHA DEL CENSO 
        //Y LA POBLACIÓN RESIDENTE HACE 5 AÑOS DIVIDIDA POR 2, MULTIPLICADO POR 1000
        TABLE DR_TASAEMI_{indexNumber}
        TABOP ( ( DR_EMIG_{indexNumber} / 5 ) / ( ( DR_RESHAB_{indexNumber} + DR_RESREC_{indexNumber} ) / 2 ) ) * 1000 
        DECIMALS 2
        TITLE \\"TASA DE EMIGRACIÓN\\"
        
        //TASA DE MIGRACIÓN: RESTA DE LA TASA DE INMIGRACIÓN MENOS LA TASA DE EMIGRACIÓN
        TABLE DR_TASAMIG_{indexNumber}
        TABOP DR_TASAINMI_{indexNumber} - DR_TASAEMI_{indexNumber}
        DECIMALS 2
        TITLE \\"TASA DE MIGRACIÓN NETA\\"
        
        //ÍNDICE DE EFICACIA: MIGRACIÓN NETA DIVIDIDA POR LA MIGRACIÓN BRUTA
        TABLE DR_EFICACIA_{indexNumber}
        TABOP DR_MIGNETA_{indexNumber} / DR_MIGBRUTA_{indexNumber}
        DECIMALS 2
        TITLE \\"INDICE DE EFICACIA MIGRATORIA\\"
        
        //TABLA RESUMEN DE INDICADORES TOTALES POR {daType} RECIENTE
        TABLELIST {daType}, DR_RESHAB_{indexNumber},   DR_RESREC_{indexNumber},  DR_NOMIGRA_{indexNumber}, DR_INMIG_{indexNumber}, DR_EMIG_{indexNumber}, DR_MIGNETA_{indexNumber}, DR_MIGBRUTA_{indexNumber},
                    DR_TASAINMI_{indexNumber}, DR_TASAEMI_{indexNumber}, DR_TASAMIG_{indexNumber}, DR_EFICACIA_{indexNumber}
        TITLE \\"{title}\\"
        OUTPUTFILE JSON \\"{outputNameJSON}.json\\" OVERWRITE
    `,
    "indexLifetime": `
        //------------------------------------------------------------------------------
        //                INDICADORES MIGRACIÓN INTERNA TODA LA VIDA ({daType})
        //------------------------------------------------------------------------------
        
        //RESIDENCIA HABITUAL
        TABLE  DN_RESHAB_{indexNumber}
        FREQ   {daType}RES
        FILTER {daType}RES > 0 AND {daType}NAC > 0 {filterText}
        TITLE  \\"RESIDENCIA HABITUAL\\"
        
        //RESIDENCIA NACIMIENTO
        TABLE  DN_RESNAC_{indexNumber}
        FREQ   {daType}NAC
        FILTER {daType}NAC > 0 AND {daType}RES > 0 {filterText}
        TITLE  \\"RESIDENCIA AL NACIMIENTO\\"
        
        //NO MIGRANTES
        TABLE  DN_NOMIGRA_{indexNumber}
        FREQ   {daType}RES
        FILTER {daType}RES = {daType}NAC {filterText}
        TITLE  \\"NO MIGRANTES\\"
        
        //INMIGRANTES: RESTA DE LA POBLACIÓN RESIDENTE A LA FECHA DEL CENSO MENOS LOS NO MIGRANTES
        TABLE DN_INMIG_{indexNumber}
        TABOP DN_RESHAB_{indexNumber} - DN_NOMIGRA_{indexNumber}
        TITLE \\"INMIGRANTES\\"
        
        //EMIGRANTES: RESTA DE LA POBLACIÓN EN SU LUGAR DE NACIMIENTO MENOS LOS NO MIGRANTES
        TABLE DN_EMIG_{indexNumber}
        TABOP DN_RESNAC_{indexNumber} - DN_NOMIGRA_{indexNumber}
        TITLE \\"EMIGRANTES\\"
        
        //MIGRACIÓN NETA: RESTA ENTRE LOS INMIGRANTES MENOS LOS EMIGRANTES 
        TABLE DN_MIGNETA_{indexNumber}
        TABOP DN_INMIG_{indexNumber} - DN_EMIG_{indexNumber}
        TITLE \\"MIGRACIÓN NETA\\"
        
        //MIGRACIÓN BRUTA: SUMA DE LOS INMIGRANTES MÁS LOS EMIGRANTES
        TABLE DN_MIGBRUTA_{indexNumber}
        TABOP DN_INMIG_{indexNumber} + DN_EMIG_{indexNumber}
        TITLE \\"MIGRACIÓN BRUTA\\"
        
        //PORCENTAJE DE INMIGRACIÓN: INMIGRANTES DIVIDIDOS POR LA POBLACIÓN RESIDENTE EN LA FECHA DEL CENSO, MULTIPLICADO POR 100 
        TABLE DN_PCINMIG_{indexNumber}
        TABOP ( DN_INMIG_{indexNumber} / DN_RESHAB_{indexNumber} ) * 100
        DECIMALS 2
        TITLE \\"PORCENTAJE DE INMIGRACIÓN\\"
        
        //PORCENTAJE DE EMIGRACIÓN: EMIGRANTES DIVIDIDOS POR LA POBLACIÓN DE NACIMIENTO, MULTIPLICADO POR 100
        TABLE DN_PCEMIG_{indexNumber}
        TABOP ( DN_EMIG_{indexNumber} / DN_RESNAC_{indexNumber} ) * 100
        DECIMALS 2
        TITLE \\"PORCENTAJE DE EMIGRACIÓN\\"  
        
        //TABLA RESUMEN DE INDICADORES TOTALES POR {daType} TODA LA VIDA
        TABLELIST {daType}, DN_RESHAB_{indexNumber},  DN_RESNAC_{indexNumber},   DN_NOMIGRA_{indexNumber}, DN_INMIG_{indexNumber}, DN_EMIG_{indexNumber},
                    DN_MIGNETA_{indexNumber}, DN_MIGBRUTA_{indexNumber}, DN_PCINMIG_{indexNumber}, DN_PCEMIG_{indexNumber}
        TITLE \\"{title}\\"
        OUTPUTFILE JSON \\"{outputNameJSON}.json\\" OVERWRITE
    `
};

const mobilityQueries = {
    "matrix": `
        //------------------------------------------------------------------------------
        //                        MATRIZ ORIGEN-DESTINO 
        //------------------------------------------------------------------------------
        
        TABLE  {tableName}
        FREQ   {daType}RES BY {daType}MCOT
        FILTER {daType}RES > 0 AND {daType}MCOT > 0 {filterText}
        ZERO   
        TITLE \\"{title}\\"
        OUTPUTFILE JSON \\"{outputNameJSON}.json\\" OVERWRITE
    `,
    "index": `
        //------------------------------------------------------------------------------
        //                INDICADORES MOVILIDAD COTIDIANA ({daType})
        //------------------------------------------------------------------------------
        
        //RESIDENCIA HABITUAL      
        TABLE DM_RES_{indexNumber}
        FREQ  {daType}RES
        FILTER {daType}MCOT > 0 AND {daType}RES > 0 {filterText}
        TITLE \\"RESIDENCIA HABITUAL SEGÚN CONDICIÓN DE MOVILIDAD\\" 
        
        //LUGAR DE MOVILIDAD
        TABLE DM_COT_{indexNumber}
        FREQ  {daType}MCOT 
        FILTER {daType}MCOT > 0 AND {daType}RES > 0 {filterText}
        TITLE \\"LUGAR DE MOVILIDAD\\"
        
        ///RESIDEN Y MUEVEN MISMO LUGAR
        TABLE DM_QUEDAN_{indexNumber}
        FREQ  {daType}MCOTM
        FILTER {cleanFilterText}
        TITLE \\"RESIDENTES SIN MOVILIDAD\\"
        
        ///RESIDEN Y TRABAJAN DIFERENTE LUGAR 
        TABLE DM_SALEN_{indexNumber}
        FREQ  {daType}MCOTD
        FILTER {cleanFilterText}
        TITLE \\"RESIDENTES QUE SALEN\\"
        
        ///NO RESIDENTE QUE LLEGA A TRABAJAR
        TABLE DM_LLEGAN_{indexNumber}
        TABOP DM_COT_{indexNumber} - DM_QUEDAN_{indexNumber}
        TITLE \\"NO RESIDENTES QUE LLEGAN\\"
        
        ///SALDO DE MÓVILES
        TABLE DM_SALDO_{indexNumber}
        TABOP DM_COT_{indexNumber} - DM_RES_{indexNumber}
        TITLE \\"SALDO DE MÓVILES\\"
        
        ///RELACIÓN TRABAJADORES/RESIDENTES
        TABLE DM_RELMR_{indexNumber}
        TABOP DM_COT_{indexNumber} / DM_RES_{indexNumber}
        TITLE \\"RELACIÓN MÓVILES | RESIDENTES\\"
        
        ///RELACIÓN SALDO/RESIDENTES POR 100
        TABLE DM_RELSM_{indexNumber}
        TABOP ( DM_SALDO_{indexNumber} / DM_RES_{indexNumber} ) * 100
        TITLE \\"RELACIÓN SALDO | RESIDENTES\\"
        
        ///RELACIÓN RESIDENTES QUE SE QUEDAN/RESIDENTES
        TABLE DM_RELQ_{indexNumber}
        TABOP DM_QUEDAN_{indexNumber} / DM_RES_{indexNumber}
        TITLE \\"RELACIÓN RESIDENTES SIN MOVILIDAD | RESIDENTES\\"
        
        ///RELACIÓN RESIDENTES QUE SALEN/RESIDENTES
        TABLE DM_RELS_{indexNumber}
        TABOP DM_SALEN_{indexNumber} / DM_RES_{indexNumber}
        TITLE \\"RELACIÓN RESIDENTES QUE SALEN | RESIDENTES\\"
        
        ///RELACIÓN NO RESIDENTES QUE LLEGAN/RESIDENTES
        TABLE DM_RELLE_{indexNumber}
        TABOP DM_LLEGAN_{indexNumber} / DM_RES_{indexNumber}
        TITLE \\"RELACIÓN NO RESIDENTES QUE LLEGAN | RESIDENTES\\"
        
        //TABLA RESUMEN DE INDICADORES TOTALES POR DAM
        TABLELIST {daType}, DM_RES_{indexNumber},   DM_COT_{indexNumber},   DM_QUEDAN_{indexNumber}, DM_SALEN_{indexNumber}, DM_LLEGAN_{indexNumber}, DM_SALDO_{indexNumber},
                    DM_RELMR_{indexNumber}, DM_RELSM_{indexNumber}, DM_RELQ_{indexNumber},   DM_RELS_{indexNumber},  DM_RELLE_{indexNumber}
        TITLE \\"{title}\\" 
        OUTPUTFILE JSON \\"{outputNameJSON}.JSON\\" OVERWRITE
    `
};

const segregationQueries = {
  'index': `
    {segregationSelection}
    TABLE T0 AS AREALIST OF {daType}, {daType}.REDLABEL, {segregationVariable} TOTAL
    DECIMALS 2
    TITLE \\"{title}\\"
    outputfile json \\"{outputNameJSON}.json\\" overwrite 
  `
};

export const buildQuery = function(
  queryType,
  resultType,
  daType,
  tableName,
  title, // Indicadores Totales para Migracion Interna Reciente | DAM
  indexNumber,
  filterText,
  outputNameJSON,
  segregationVariable,
  segregationSelection
) {
  
  let templateText = '';

  switch (queryType) {
    case 'migration':
      if (resultType === 'matrixRecently') {
        templateText = migrationQueries.matrixRecently;
      } else if (resultType === 'matrixLifetime') {
        templateText = migrationQueries.matrixLifetime;
      } else if (resultType === 'indexRecently') {
        templateText = migrationQueries.indexRecently;
      } else if (resultType === 'indexLifetime') {
        templateText = migrationQueries.indexLifetime;
      }
      break;
    case 'mobility':
      if (resultType === 'matrix') {
        templateText = mobilityQueries.matrix;
      } else if (resultType === 'index') {
        templateText = mobilityQueries.index;
      } 
      break;
    case 'segregation':
      templateText = segregationQueries.index;
      break;
    default:
      break;
  }

  templateText = templateText.replaceAll('{daType}', daType);
  templateText = templateText.replaceAll('{tableName}', tableName);
  templateText = templateText.replaceAll('{title}', title);
  templateText = templateText.replaceAll('{indexNumber}', indexNumber);
  templateText = templateText.replaceAll('{outputNameJSON}', outputNameJSON);

  // Specific for segregation
  templateText = templateText.replaceAll('{segregationVariable}', segregationVariable);
  templateText = templateText.replaceAll('{segregationSelection}', segregationSelection);

  if (filterText !== '') {
    templateText = templateText.replaceAll('{filterText}', `AND (${filterText})`);
    templateText = templateText.replaceAll('{cleanFilterText}', `(${filterText})`);
  } else {
    templateText = templateText.replaceAll('{filterText}', '');
    templateText = templateText.replaceAll('FILTER {cleanFilterText}', ``);
  }

  return (templateText)
};